import {fetchRemoteResult,postRemote,putRemoteResult,fetchRemoteJson} from '../../Api/api-util';
import securityApi from '../../Util/security';

const supportEndpoint = '/api/Support/';
const sprintPlanningEndpoint = '/api/SprintPlanning/';

const jiraBaseUrl = 'https://datanext.atlassian.net/browse/';

export default {
    getIssues(jiraFilterType, startAt) {
        return fetchRemoteJson(
            `${supportEndpoint}SprintIssue?selectedFilter=${jiraFilterType}&startAt=${startAt}&raw=true`
        );
    },
    getIssueTypes() {
        return fetchRemoteResult(`${sprintPlanningEndpoint}IssueTypes`);
    },
    getFilters() {
        return fetchRemoteResult(`${sprintPlanningEndpoint}Filters`);
    },
    getUsers() {
        return fetchRemoteResult(`${sprintPlanningEndpoint}Users`);
    },
    getComments(key) {
        return new Promise((resolve, reject) => {
            fetchRemoteResult(`${sprintPlanningEndpoint}Comments?key=${key}`).then(
                (response) => {
                    let comments = response.comments;
                    comments = comments ? comments.reverse() : []; //last comment first
                    resolve(comments);
                },
                reject
            ).catch(reject);
        });
    },
    getPriorities() {
        return fetchRemoteResult(`${sprintPlanningEndpoint}Priorities`);
    },
    getMetadata(projectKey) {
        return fetchRemoteResult(`${sprintPlanningEndpoint}Metadata?projectKey=${projectKey}`);
    },
    getStatuses() {
        return fetchRemoteResult(`${sprintPlanningEndpoint}Status`);
    },
    getIssueMeta(key) {
        return fetchRemoteResult(`${sprintPlanningEndpoint}IssueMeta?key=${key}`);
    },
    getTransitions(key) {
        return fetchRemoteResult(`${sprintPlanningEndpoint}Transitions?key=${key}`);
    },
    getAttachments(key) {
        return new Promise((resolve, reject) => {
            fetchRemoteResult(`${sprintPlanningEndpoint}Attachments?key=${key}`).then(
                (response) => {
                    const attachments = response.fields.attachment;
                    resolve(attachments || []);
                },
                reject
            ).catch(reject);
        });
    },
    postTransition(key, transition) {
        return postRemote(`${sprintPlanningEndpoint}Transition`, { key, transition });
    },
    putAssignee(key, accountId) {
        return putRemoteResult(`${sprintPlanningEndpoint}Assignee`, { key, accountId });
    },
    putIssue(key, update) {
        return putRemoteResult(`${sprintPlanningEndpoint}PutIssue`, { key, update });
    },

    validateCommentsReadPermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningComments,
            securityApi.PermissionGrantTypes.Read
        );
    },
    validateCommentsWritePermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningComments, 
            securityApi.PermissionGrantTypes.Write
        );
    },
    validateTimeTrackingReadPermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningTimeTracking,
            securityApi.PermissionGrantTypes.Read
        );
    },
    validateTimeTrackingWritePermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningTimeTracking,
            securityApi.PermissionGrantTypes.Write
        );
    },
    
    jiraBaseUrl
};
